// ── Toggle del panel de categoría ─────────────────────────────
function toggleDresscodePanel(categoryEl) {
    categoryEl.classList.toggle('open');
}
// ── Lightbox de imagen de referencia ──────────────────────────
function openDresscodeLightbox(slotEl) {
    const imgEl = slotEl.querySelector('img');
    if (!imgEl) return;
    const lightbox = document.getElementById('dresscode-lightbox');
    const lightboxImg = document.getElementById('dresscode-lightbox-img');
    if (!lightbox || !lightboxImg) return;
    document.documentElement.style.overflowY = 'hidden';
    lightboxImg.src = imgEl.src;
    lightbox.classList.add('open');
}
function closeDresscodeLightbox() {
    const lightbox = document.getElementById('dresscode-lightbox');
    if (!lightbox || !lightbox.classList.contains('open')) return;
    lightbox.classList.remove('open');
    document.documentElement.style.overflowY = '';
}
function initDresscodeLightbox() {
    const lightbox = document.getElementById('dresscode-lightbox');
    const closeBtn = document.getElementById('dresscode-lightbox-close');
    if (!lightbox) return;
    lightbox.addEventListener('click', closeDresscodeLightbox);
    closeBtn?.addEventListener('click', (e)=>{
        e.stopPropagation();
        closeDresscodeLightbox();
    });
    const lightboxImg = document.getElementById('dresscode-lightbox-img');
    lightboxImg?.addEventListener('click', (e)=>e.stopPropagation());
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape') closeDresscodeLightbox();
    });
}

//# sourceMappingURL=public.ced285b0.js.map
